export default __webpack_public_path__ + "static/media/avatarA5.666d1c61.png";